<template lang="html">
  <v-app>
    <section class="about">
      <SubTitle
        :TitleName="'http://d-mebius.com/miasmabreaker/assets/index_story.png'"
        :AltText="'物語'"
      />
      <div class="story_page page-bottom" key="story_page">
        <SubTitle
          :TitleName="'http://d-mebius.com/miasmabreaker/assets/caption_02.png'"
          :AltText="'夜の街に現れる悪霊「ミアズマ」を除霊せよ！'"
        />
        <div class="text-column">
          <p>
            寝静まった宵の刻、災いを呼ぶ悪霊『ミアズマ』がうごめいていた。<br />
            主人公の『如月
            忍』は世界除霊機関に所属するエージェントで、人々を脅かすミアズマを除霊する任務に就くことに。<br />
            新米エージェント如月 忍はお供の守護霊と共に夜の街を駆け巡る――！
          </p>
        </div>

        <v-container>
          <v-row
            v-for="(character, index) in characters"
            :key="index"
            justify-center
          >
            <v-col style="text-align: center;" cols="12" md="6"
              ><img :src="character.src" :alt="character.alt"
            /></v-col>
            <v-col cols="12" md="6"
              ><p class="text-h5">{{ character.name }}</p>
              <p v-html="formatDescription(character.description)"></p
            ></v-col>
          </v-row>
        </v-container>
      </div>
    </section>
  </v-app>
</template>

<style></style>
<script>
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      SubTitle,
    },
    data() {
      return {
        characters: [
          {
            src: "http://d-mebius.com/miasmabreaker/assets/cha_01.png",
            alt: "如月 忍（きさらぎ しのぶ）",
            name: "如月 忍（きさらぎ しのぶ）",
            description:
              "霊力を操り悪霊『ミアズマ』を除霊する力を持つ女性。<br>表向きは『あらいずみ探偵事務所』に所属する探偵という身分だが、夜の街に現れるミアズマを除霊する世界除霊機関のエージェントでもある。持ち前のやる気と前向きさで除霊任務に挑む。<br>キツネ型の守護霊である『風刃の守護霊』は幼い頃からの友達であり、ミアズマ退治の相棒でもある。",
          },
          {
            src: "http://d-mebius.com/miasmabreaker/assets/cha_02.png",
            alt: "荒泉 光太郎（あらいずみ こうたろう）",
            name: "荒泉 光太郎（あらいずみ こうたろう）",
            description:
              "『あらいずみ探偵事務所』の所長。<br>探偵事務所を経営しながらミアズマ除霊の仕事も請け負っている。<br>忍にミアズマ除霊の技術を指導したこともあり、彼女からは先生と慕われている。<br>昼間は探偵事務所を経営しているが、夜間はミアズマ除霊もこなしている苦労人。",
          },
          {
            src: "http://d-mebius.com/miasmabreaker/assets/cha_03.png",
            alt: "風刃の守護霊（ふうじんのしゅごれい）",
            name: "風刃の守護霊（ふうじんのしゅごれい）",
            description:
              "風を操るキツネ型の守護霊。古くから如月家と共に生きていて、忍にとっては幼い時から共に過ごしてきた大切な友達といえる存在。忍とは直接会話はできないが、お互いの意思は通じているようだ。<br><br>通常攻撃は扱いやすい連射型。<br>守護霊攻撃は近距離攻撃を得意とするが、範囲攻撃もこなす万能型。",
          },
          {
            src: "http://d-mebius.com/miasmabreaker/assets/cha_04.png",
            alt: "水沫の守護霊（すいまつのしゅごれい）",
            name: "水沫の守護霊（すいまつのしゅごれい）",
            description:
              "水を操るヘビ型の守護霊。ある除霊任務で忍と出会い、力を貸してくれることになった。冷静で落ち着いた性格をしている。<br><br>通常攻撃は射程が長い遠距離型。<br>守護霊攻撃も遠距離中心で、成長すると範囲攻撃に特化するようになる。",
          },
          {
            src: "http://d-mebius.com/miasmabreaker/assets/cha_05.png",
            alt: "雷光の守護霊（らいこうのしゅごれい）",
            name: "雷光の守護霊（らいこうのしゅごれい）",
            description:
              "雷を操るカラス型の守護霊。ある除霊任務で忍と出会い、力を貸してくれることになった。ノリが良く調子の良い喋り方が特徴。<br><br>通常攻撃は広範囲に攻撃できる拡散型。<br>守護霊攻撃は一定時間自律攻撃をする特殊型。クセはあるが特徴を活かせば高い殲滅力を発揮する。",
          },
        ],
      };
    },
    methods: {
      formatDescription(description) {
        return description.replace(/\n/g, "<br>");
      },
    },
  };
</script>
